<template>
  <v-toolbar
    color="primary"
    dark
    flat
    class="dialog-toolbar dialog-drag-handle"
  >
    <v-icon class="mr-3" aria-hidden="true">{{ icon }}</v-icon>
    <v-toolbar-title
      :id="titleId"
      class="text-subtitle-1 font-weight-bold"
      role="heading"
      aria-level="2"
    >
      {{ title }}
    </v-toolbar-title>
    <v-spacer />
    <v-btn
      icon
      :disabled="disabled"
      :aria-label="`Close ${title}`"
      @click="$emit('cancel')"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {
  name: "CardToolbarDialog",
  props: {
    title: { type: String, required: true },
    icon: { type: String, default: "mdi-shield-lock-outline" },
    titleId: { type: String, required: true },
    disabled: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.dialog-toolbar {
  flex: 0 0 auto;
}
</style>
